export interface FaqItem {
  question: string;
  answer: string;
}

export const homeFaqs: FaqItem[] = [
  {
    question: '爆料直播网的今日直播排期多久更新一次？',
    answer:
      '排期每 15 分钟自动校对一次，遇到临时改档或加场会立即刷新。最终开播时间以主播的开播通知为准，页面上的时间可作为提前安排的参考。',
  },
  {
    question: '即将开始场次怎么设置直播预告提醒？',
    answer:
      '在对应场次卡片上点击「设提醒」即可记录到你的清单中；也可以订阅直播预告提醒，我们会把当天重点场次的开始时间提前发到你的邮箱。',
  },
  {
    question: '直播回放列表会保留多久？',
    answer:
      '常规场次的回放一般保留 30 天，热点专题场次会延长到 90 天。回放页可按分类筛选，也能直接查看时长和播放量，方便挑重点补课。',
  },
  {
    question: '热门直播推荐是按什么规则排出来的？',
    answer:
      '综合同时在线人数、互动频率、近一小时热度增幅和回放点播量计算，每小时刷新一次，所以榜单会随直播进行动态变化。',
  },
  {
    question: '同一时间有几场想看的直播怎么办？',
    answer:
      '建议优先看回放保留时间较短或互动性更强的场次，其余场次可以设提醒并排进回放清单，第二天集中补看，不会漏掉重点内容。',
  },
  {
    question: '发现排期信息有误应该怎么反馈？',
    answer:
      '可以通过页面底部的联系邮箱说明具体场次和问题，我们会尽快核对来源并更新。涉及时间调整的反馈会被优先处理。',
  },
];

export const aboutFaqs: FaqItem[] = [
  {
    question: '爆料直播网的内容来源是什么？',
    answer:
      '排期信息来自各直播间公开的开播预告与主播发布的场次安排，我们只做整理、校对和呈现，不参与任何直播内容的制作。',
  },
  {
    question: '网站会收录哪些类型的直播？',
    answer:
      '目前覆盖娱乐爆料、财经观察、游戏电竞、生活好物、科技前沿、体育赛事、情感夜话和音乐现场八个方向，后续会根据观众反馈调整栏目。',
  },
  {
    question: '为什么有些场次没有回放？',
    answer:
      '是否提供回放由主播本人决定。涉及版权或嘉宾意愿的场次可能不保留录像，我们会在这类场次上做出标注。',
  },
  {
    question: '爆料直播网会向观众收费吗？',
    answer:
      '浏览排期、查看回放列表和设置提醒都是免费的。网站不代收任何打赏或门票费用，如遇到收费页面请谨慎辨别。',
  },
];